module.exports = __webpack_public_path__ + "static/media/down-blue.55905984.svg";